import React from "react";
import { Link } from "react-router-dom";
import { profile } from "./content";
import { Arrow } from "./Icons";
import SiteMeta from "./SiteMeta";

export default function Resume() {
  return (
    <>
      <SiteMeta
        title="Résumé"
        path="/resume"
        description="Hunter Grey’s background and résumé. Explore current projects, experience, and education, or open the English PDF."
      />
      <header className="page-intro">
        <h1>
          Résumé<span>.</span>
        </h1>
        <p>
          My background is in electrical engineering, AI, and robotics. My
          current work is in developer tools and personal software.
        </p>
      </header>
      <section className="resume-panel">
        <div className="resume-paper" aria-hidden="true">
          <span>Isaac Grey</span>
          <i />
          <i />
          <b />
          <i />
          <i />
          <b />
          <i />
          <i />
        </div>
        <div>
          <h2>A little more background</h2>
          <p>
            The PDF is available in English. For what I’m building now, start
            with the projects page.
          </p>
          <div className="resume-actions">
            <a
              className="button"
              href={profile.resume}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open résumé (PDF) <Arrow diagonal />
            </a>
            <a
              className="text-link"
              href={profile.resume}
              download="Isaac-Grey-resume-en.pdf"
            >
              Download PDF <span aria-hidden="true">↓</span>
            </a>
          </div>
        </div>
      </section>
      <div className="resume-related">
        <Link to="/projects">
          <h2>
            Current projects <Arrow />
          </h2>
          <p>NeoVibe, Skuld, and draupnir.</p>
        </Link>
        <Link to="/about#experience">
          <h2>
            Experience &amp; education <Arrow />
          </h2>
          <p>Research, internships, and the path here.</p>
        </Link>
      </div>
    </>
  );
}
